<div class="container">
    <div class="row">
        <div style="width:100%;" class="ps-0 pe-0">
            <div class="card-body">
                <div *ngIf="linkMyCase">
                    <h1 class="static-text">{{'MY_LETTERS_STATIC_TEXT1' | globalTranslate }}<a
                        [routerLink]="['/user-profile', 'case-link']"><strong>{{'MY_LETTERS_STATIC_TEXT2' | globalTranslate}}</strong></a> {{'MY_LETTERS_STATIC_TEXT3' | globalTranslate}}
                    </h1>
                </div>
                <div *ngIf="!linkMyCase">
                <h1 class="static-text">{{'MY_LETTERS_STATIC_TEXT4' | globalTranslate }}</h1>
                <p [innerHTML]="'ELIGIBILITY_LETTERS_TEXT' | globalTranslate"></p>
                <div> <strong>{{'NOTE' | globalTranslate }} </strong> {{'MY_LETTERS_STATIC_TEXT5' | globalTranslate }}</div>
                <p class="mt-3">{{'MY_LETTERS_STATIC_TEXT6' | globalTranslate }}
                    <nh-popover class="ps-1"
                        content="{{'MY_LETTERS_STATIC_TEXT7' | globalTranslate }}">
                    </nh-popover>
                </p>
                <form [formGroup]="search">
                            <nh-field label="{{'TYPE_OF_LETTER' | globalTranslate}}" [isRow]="true" [mandatory]="false" [attr.aria-required]="false" class="label-section">
                                <select nhTranslate name="type" [attr.aria-label]="'TYPE_OF_LETTER' | globalTranslate" [items]="items" formControlName="type" bindLabel="value"
                                    bindValue="code"></select>
                            </nh-field>
                        <div class="row g-3">
                        <div class="col-md-6">
                            <nh-field label="{{'BEGIN_DATE' | globalTranslate }}" [isRow]="true" [mandatory]="false" [attr.aria-required]="false" class="label-section">
                                <nh-datepicker>
                                    <input type="text" [attr.aria-label]="'BEGIN_DATE' | globalTranslate" name="beginDate" class="form-control" formControlName="beginDate" [minDate]="minimumDate" [maxDate]="today"
                                        (bsValueChange)="verifyTwoDates($event, 'beginDate')"
                                            (change)="verifyTwoDates($event, 'beginDate')"  bsDatepicker nh>
                                </nh-datepicker>
                                 <div *ngIf="beginDateError?.isError" class="error-messages position-relative">
                                        <span class="form-text invalid-tooltip d-block">{{beginDateError.errorMessage | globalTranslate}}</span>
                                    </div>
                            </nh-field>
                        </div>
                        <div class="col-md-6">
                            <nh-field label="{{'END_DATE' | globalTranslate }}" [isRow]="true" [mandatory]="false" [attr.aria-required]="false" class="label-section">
                                <nh-datepicker>
                                    <input type="text" [attr.aria-label]="'END_DATE' | globalTranslate" name="endDate" class="form-control" formControlName="endDate" [minDate]="minimumDate" [maxDate]="today"
                                        (bsValueChange)="verifyTwoDates($event, 'endDate')" (change)="verifyTwoDates($event, 'endDate')" bsDatepicker nh>
                                </nh-datepicker>
                                 <div *ngIf="endDateError?.isError" class="error-messages position-relative">
                                        <span class="form-text invalid-tooltip d-block">{{endDateError.errorMessage | globalTranslate}}</span>
                                    </div>
                            </nh-field>
                          </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                        <button id="continue" [disabled]="(beginDateError?.isError) || (endDateError?.isError) || !this.search.controls.beginDate.value || !this.search.controls.endDate.value || this.search.controls.beginDate.invalid || this.search.controls.endDate.invalid" class="btn btn-secondary btn-search" (click)="searchData()">{{'SEARCH' | globalTranslate }} <i
                                class="fa fa-search ms-2"></i></button>
                        </div>
                    </div>
                </form>
                <div class="mt-3" *ngIf="rows?.length">
                    <div class="d-none d-lg-block my-letters-desktop-table">
                        <h1 class="label-section"><strong>{{'DISPLAYING' | globalTranslate }} {{start}}-{{end}} {{'OF' | globalTranslate }} {{rows.length}}
                                {{'NOTICE' | globalTranslate }}</strong></h1>
                        <ngx-datatable class='bootstrap material' #table [rows]='rows' [columnMode]='"force"'
                            [headerHeight]='50' [footerHeight]='50' [rowClass]="getRowClass" [rowHeight]='"auto"'
                            [limit]="5" (page)="onPage($event)" [messages]="{emptyMessage: this.emptyMessage}">
                            <ngx-datatable-column name="{{'Letter Name' | globalTranslate}}" [width]="250">
                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                    <div class="letter-name-wrapper">
                                        <img src="../../assets/images/Icons/Open_Letter.svg" alt="close-icon" height="20px" *ngIf="row.viewed == 'Yes'"/>
                                        <img src="../../assets/images/Icons/Close_Letter.svg" alt="close-icon" height="20px" *ngIf="row.viewed == 'No'"/>
                                        <div class="letter-name">
                                            {{row.letterName}}
                                            <div *ngIf="budgetInfoSwitch && (row.letterDescription?.includes('(TN 301)') || row.letterDescriptionES?.includes('(TN 301)')) && !row.methodSentDescription?.includes('Summary Unavailable') && row.privacySuppressSW !== 'Y'" class="mt-1">
                                                <a class="p-0 text-start view_budget action-link" tabindex="0" (click)="viewBudget(row)" (keydown.enter)="viewBudget(row)" (keydown.space)="$event.preventDefault(); viewBudget(row)">{{'VIEW_BUDGET' | globalTranslate}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="{{'Letter For' | globalTranslate }}" [width]="145">
                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                    <div>
                                        {{row.letterFor}}
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="{{'DATE' | globalTranslate }}" [width]="128">
                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                    <div>
                                        {{row.date}}
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="{{'Letter Viewed?' | globalTranslate }}" [width]="120" headerClass="text-center">
                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                    <div class="text-center">
                                        {{row.viewed}}
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                           <!-- <ngx-datatable-column [name]="col.name" [prop]="col.prop" *ngFor="let col of columns">
                            </ngx-datatable-column>-->
                            <ngx-datatable-column name="{{(budgetInfoSwitch ? 'VIEW_NOTICE' : 'View') | globalTranslate }}" [width]="220" headerClass="text-center">
                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                    <div class="p-0 text-center">
                                        @if (privacyNoticeViewSw && row.privacySuppressSW === 'Y') {
                                            <span class="d-inline-flex align-items-center" style="white-space: nowrap">
                                                <ng-container *ngTemplateOutlet="privacyUnavailBtn"></ng-container>
                                            </span>
                                        } @else {
                                            <a class="p-0 text-start hover-red btn btn-link" tabindex="0"
                                        (click)="printPdf(row)"><i
                                            class="fa fa-search fa-lg"></i></a>
                                        }
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                        <button *ngIf="rows.length && isAppealLetter && !isFromPartnerPortal" id="myAppeals" class="btn d-grid btn-primary mt-3 ml-0" (click)="goToMyAppeals()">
                            {{'MY_APPEALS' | globalTranslate}}
                          </button>
                    </div>
                    <div class="nh-table-mobile mt-3 pt-2 d-lg-none">
                    <div class="table-row mb-3 pb-3" *ngFor="let row of rows; index as i"  [ngClass]="{'row-highlight': row.viewed === 'No', 'privacy-suppressed': row.privacySuppressSW === 'Y'}"> 
                            <div>
                                <div class="mobile-table-header">{{'Letter Name' | globalTranslate }}</div>
                                <hr>
                                <div class="letter-name-wrapper">
                                    <img src="../../assets/images/Icons/Open_Letter.svg" alt="close-icon" height="20px" *ngIf="row.viewed == 'Yes'"/>
                                    <img src="../../assets/images/Icons/Close_Letter.svg" alt="close-icon" height="20px" *ngIf="row.viewed == 'No'"/>
                                    <div class="letter-name">
                                        {{row.letterName}}
                                        <div *ngIf="budgetInfoSwitch && (row.letterDescription?.includes('(TN 301)') || row.letterDescriptionES?.includes('(TN 301)')) && !row.methodSentDescription?.includes('Summary Unavailable') && row.privacySuppressSW !== 'Y'" class="mt-1">
                                            <a class="p-0 text-center view_budget action-link" tabindex="0" (click)="viewBudget(row)" (keydown.enter)="viewBudget(row)" (keydown.space)="$event.preventDefault(); viewBudget(row)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="23.181" height="23.181" viewBox="0 0 23.181 23.181">
                                                    <g id="list-circle-outline_1_" data-name="list-circle-outline (1)" transform="translate(-63.25 -65.25)">
                                                        <path id="Path_824" data-name="Path 824" d="M224,184h7.227M224,188.065h7.227M224,192.074h7.227"
                                                            transform="translate(-150.966 -111.338)" fill="none" stroke="#174a7c" stroke-linecap="round"
                                                            stroke-linejoin="round" stroke-width="1.5" />
                                                        <path id="Path_825" data-name="Path 825"
                                                            d="M85.681,76.84a10.84,10.84,0,1,0-10.84,10.84A10.843,10.843,0,0,0,85.681,76.84Z" fill="none"
                                                            stroke="#174a7c" stroke-miterlimit="10" stroke-width="1.5" />
                                                        <circle id="Ellipse_1" data-name="Ellipse 1" cx="0.5" cy="0.5" r="0.5" transform="translate(69 72)"
                                                            fill="none" stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                        <circle id="Ellipse_2" data-name="Ellipse 2" cx="0.5" cy="0.5" r="0.5" transform="translate(69 76)"
                                                            fill="none" stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                        <circle id="Ellipse_3" data-name="Ellipse 3" cx="0.5" cy="0.5" r="0.5" transform="translate(69 80)"
                                                            fill="none" stroke="#174a7c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                                    </g>
                                                </svg>
                                                {{'VIEW_BUDGET' | globalTranslate}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <br>
                            </div>
                            <div *ngFor="let head of columns">
                                <div class="mobile-table-header" [innerHtml]="head.name | globalTranslate| sanitize"></div>
                                <hr>
                                <div class="mobile-table-data"
                                    [innerHTML]="row[head.prop] | sanitize">
                                </div>
                                <br>
                            </div>
                            @if (privacyNoticeViewSw && row.privacySuppressSW === 'Y') {
                                <div>
                                    <div class="mobile-table-header">{{(budgetInfoSwitch ? 'VIEW_NOTICE' : 'View') | globalTranslate}}</div>
                                    <hr>
                                    <div class="mobile-table-data d-inline-flex align-items-center mb-2" style="white-space: nowrap">
                                        <ng-container *ngTemplateOutlet="privacyUnavailBtn"></ng-container>
                                    </div>
                                    <br>
                                </div>
                            } @else {
                                <button class="btn btn-sm btn-secondary w-100"
                                (click)="printPdf(row)">
                                <span class="pe-2">{{(budgetInfoSwitch ? 'VIEW_NOTICE' : 'View') | globalTranslate }}</span>
                            </button>
                            }
                        </div>
                        <button *ngIf="rows.length && isAppealLetter && !isFromPartnerPortal" id="myAppeals" class="btn btn-sm btn-primary mt-3 appeal-btn w-100" (click)="goToMyAppeals()">
                            {{'MY_APPEALS' | globalTranslate}}
                        </button>
                        <p *ngIf="!rows.length" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p>
                    </div>
                </div>
                <ng-template #privacyUnavailBtn>
                    <span>{{'Unavailable' | globalTranslate}}</span>
                    <button type="button"
                        class="btn-popover nh-popover ms-1"
                        [popover]="privacyTip"
                        container="body"
                        containerClass="popover-tooltip privacy-interactive-popover"
                        placement="top"
                        [adaptivePosition]="true"
                        triggers="outsideClick"
                        #privPop="bs-popover"
                        (mouseenter)="showPrivacyPopover(privPop)"
                        (mouseleave)="hidePrivacyPopover(privPop)"
                        (click)="togglePrivacyPopover($event, privPop)"
                        (onHidden)="onPrivacyPopoverHidden()"
                        tabindex="0"
                        [attr.aria-label]="privacyTooltipLabel">
                        <img src="assets/images/Icons/tool-tip-icon.svg" alt="" aria-hidden="true"/>
                    </button>
                </ng-template>
                <ng-template #privacyTip>
                    <div class="privacy-tip-content"
                         (click)="onPrivacyToolTipContentClick($event)"
                         (mouseenter)="showPrivacyPopover(currentPrivacyPop)"
                         (mouseleave)="hidePrivacyPopover(currentPrivacyPop)"
                         [innerHTML]="privacyTooltipContent | sanitize">
                    </div>
                </ng-template>
                <div *ngIf="rows?.length === 0">
                    <br>
                    <p class="mt-3">{{this.emptyMessage | globalTranslate}}</p>
                </div>
                </div>
            </div>
        </div>
    </div>